<svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12">
  <path fill="#21C286" fill-rule="nonzero" stroke="#FFF" stroke-width=".5"
        d="M13.24 1.138a1.324 1.324 0 1 1 1.872 1.871l-7.94 7.942a1.324 1.324 0 0 1-1.873 0L.888 6.539a1.324 1.324 0 0 1 1.871-1.872l3.476 3.476 7.006-7.005z"/>
</svg>
